import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import Media from '@ep/components/Media';
import { Body2, Body3, H4 } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_Asset, Gcms_Post } from '@ep/types/gatsbyTypes';
import truncate from '@ep/utils/truncate';
import { DateTime } from 'luxon';
import React from 'react';

export interface CuratedPostProps {
  curatedPost: Gcms_Post;
}

const Wrapper = styled(Link)`
  margin-top: 1rem;
  display: flex;
  align-items: flex-start;
  margin-left: -1rem;
  margin-bottom: 0rem;
  :hover {
    text-decoration: none;
  }
  @media (max-width: ${theme.breakpoints.optimalTablet + 400}px) {
    margin-bottom: 3.5rem;
  }
`;

const StyledMedia = styled(Media)`
  margin-left: 2rem;
  margin-right: 0.5rem;
  flex: 3;
  max-height: 7rem;
  overflow: hidden;
  @media (max-width: ${theme.breakpoints.optimalTablet + 400}px) {
    max-width: 10rem;
  }
`;

const Texts = styled.div`
  max-width: 25rem;
  flex: 5;
  font-family: ${theme.typography.secondaryFont.regular};
  margin-left: 0.5rem;

  ${theme.mediaQueries.mobile} {
    margin-left: 1.5rem;
  }
`;

const StyledBody2 = styled(Body2)`
  line-height: 1.1rem;
  font-size: 0.9rem;
  max-width: 15rem;
  @media (max-width: 1024px) {
    font-size: 0.8rem;
    max-width: 100%;
  }
`;

const StyledBody3 = styled(Body3)`
  margin-top: 0rem;
  color: ${theme.colors.darkGray};
  font-size: 0.8rem;
  font-family: ${theme.typography.primaryFont};
`;

const Heading = H4.withComponent('h3');

const StyledHeading = styled(Heading)`
  line-height: 1.1rem;
  font-size: 1rem !important;
  color: ${theme.colors.duskBlue};
  margin-top: 0.2rem;
  margin-bottom: 0.5rem;
`;

function CuratedPost({ curatedPost }: CuratedPostProps) {
  const displayDate = DateTime.fromISO(curatedPost.displayDate);

  return (
    <Wrapper to={`/${curatedPost.slug}`}>
      <StyledMedia
        media={curatedPost.featuredImage as Gcms_Asset}
        aspectRatio={6 / 4.5}
        cover
        lazy
      />
      <Texts>
        <StyledBody3>
          {displayDate.toLocaleString(DateTime.DATE_SHORT)}
        </StyledBody3>
        <StyledHeading>{truncate(curatedPost.title, 90)}</StyledHeading>
        {<StyledBody2>{truncate(curatedPost.description, 63)}</StyledBody2>}
      </Texts>
    </Wrapper>
  );
}

export default CuratedPost;
